import axios, { AxiosInstance } from "axios"

class WebFileApi {
	private axios: AxiosInstance;

	constructor () {
		this.axios = axios.create()
	}

	public async serviceError (): Promise<string> {
		return (await this.axios.get("serviceerror.htm")).data
	}
}

const api = new WebFileApi()
export default api
